<template>
  <Container>
    <PageHeader :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex flex-wrap align-items-center justify-content-between">
              <h4 class="card-title">Bookings</h4>
              <b-button @click="$root.$emit('clearBooking')" v-b-modal.booking-modal variant="outline-primary">
                Add Bookings
              </b-button>
            </div>

            <Booking :reservations="bookings" @submit="setBooking" />

            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length mb-3">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select class="mx-1" v-model="perPage" size="sm" :options="pageOptions"></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-right">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>

            <div class="table-responsive mb-0">
              <b-table
                :items="bookingItems"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template v-slot:cell(status)="row">
                  <b-badge pill :variant="getBadge(row.item.status)">{{ row.item.status }}</b-badge>
                </template>

                <template v-slot:cell(actions)="row">
                  <b-dropdown variant="default" dropleft>
                    <template v-slot:button-content>
                      <i class="fas fa-bars"></i>
                      <i class="bx bx-caret-down"></i>
                    </template>

                    <b-dropdown-item v-b-modal.booking-modal @click="$root.$emit('toggleEdit', row.item.id)">
                      <i class="fa fa-pencil-alt"></i>
                      Edit
                    </b-dropdown-item>

                    <b-dropdown-item :to="{ path: `/bookings/${row.item.id}` }">
                      <i class="fa fa-info-circle"></i>
                      Details
                    </b-dropdown-item>

                    <b-dropdown-item link-class="text-primary">
                      <i class="fas fa-check"></i>
                      Approve
                    </b-dropdown-item>

                    <b-dropdown-item link-class="text-danger">
                      <i class="fa fa-times"></i>
                      Cancel
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
              </b-table>
            </div>

            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../layouts/main";
import PageHeader from "@/components/page-header";
import Booking from "@/components/booking";
import appConfig from "@/app.config";
import { getBookings } from "@/store/api";
import moment from "moment";

export default {
  page: {
    title: "Bookings",
    meta: [{ name: "description", content: appConfig.description }],
  },

  components: {
    Container,
    PageHeader,
    Booking,
  },

  data() {
    return {
      bookings: [],
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Bookings",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "",
      sortDesc: false,
      fields: [
        { key: "arrival" },
        { key: "departure" },
        { key: "accommodation" },
        { key: "customer" },
        { key: "created_at" },
        { key: "status" },
        { key: "actions", tdClass: "text-right" },
      ],
    };
  },

  created() {
    getBookings().then((response) => (this.bookings = response));
  },

  mounted() {
    this.totalRows = this.items.length;
  },

  computed: {
    rows() {
      return this.bookingItems.length;
    },

    bookingItems() {
      return this.bookings.map((booking) => {
        return {
          id: booking.id,
          arrival: this.convertToDate(booking.attributes.reservations.data[0].attributes.checkin),
          departure: this.convertToDate(booking.attributes.reservations.data[0].attributes.checkout),
          accommodation: booking.attributes.reservations.data[0].attributes.lodging.name,
          customer: `${booking.attributes.customer.first_name} ${booking.attributes.customer.last_name}`,
          created_at: this.convertToDateTime(booking.attributes.reservations.data[0].attributes.created_at),
          status: booking.attributes.booking_status,
        };
      });
    },
  },

  methods: {
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    convertToDate(date) {
      return moment(date).format("MMM D, YYYY");
    },

    convertToDateTime(date) {
      return moment(date).format("MMM D, YYYY hh:mm a");
    },

    getBadge(status) {
      return status == "prebooked" ? "primary" : status == "booked" ? "success" : "danger";
    },

    setBooking(booking) {
      this.bookings.push(booking);
    },
  },
};
</script>
